import React, { useState } from 'react';
import { Alert, Box, Button, CircularProgress, Snackbar, TextField, Typography } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { useNavigate } from 'react-router-dom';
import AuthLayout from '../components/layout/AuthLayout';
import { API_URL } from '../api';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [notice, setNotice] = useState({ open:false, message:'', severity:'error' });
  const navigate = useNavigate();
  const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleContinue = async (event) => {
    event.preventDefault();
    if (!valid) { setNotice({ open:true, message:'Enter a valid email address.', severity:'error' }); return; }
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/api/v1/users/check`, { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify({ email }) });
      if (!response.ok) throw new Error('We could not check that account. Please try again.');
      const data = await response.json();
      navigate(data.userExists ? '/signin' : '/signup', { state:{ email } });
    } catch (error) { setNotice({ open:true, message:error.message, severity:'error' }); }
    finally { setLoading(false); }
  };

  return <AuthLayout eyebrow="Club account" title="Welcome to DGFC" description="Enter your email and we’ll take you to the right place—sign in if you already have an account, or create one if you’re new.">
    <Box component="form" onSubmit={handleContinue} noValidate><TextField autoFocus fullWidth label="Email address" type="email" value={email} onChange={(event) => setEmail(event.target.value)} error={email.length > 0 && !valid} helperText={email.length > 0 && !valid ? 'Use a valid email format' : ' '} InputProps={{ startAdornment:<EmailOutlinedIcon sx={{ color:'text.disabled', mr:1 }} /> }} sx={{ mb:1 }} /><Button fullWidth type="submit" variant="contained" size="large" disabled={loading} endIcon={loading ? <CircularProgress size={18} color="inherit" /> : <ArrowForwardRoundedIcon />}>Continue</Button></Box>
    <Typography color="text.secondary" textAlign="center" variant="body2" sx={{ mt:3 }}>Your account keeps your supporter details and club access in one place.</Typography>
    <Snackbar open={notice.open} autoHideDuration={5000} onClose={() => setNotice((value) => ({ ...value, open:false }))} anchorOrigin={{ vertical:'top', horizontal:'center' }}><Alert severity={notice.severity} onClose={() => setNotice((value) => ({ ...value, open:false }))}>{notice.message}</Alert></Snackbar>
  </AuthLayout>;
};
export default LoginPage;
